// 用户api
import request from "./api";

// -------------------------资源统计 管理员------------------------------
// 组织管理-管理员-获取机构下一级组织
export const queryStructFirstLevel = (params, opts) => request(`/api-user/sys/struct/queryStructFirstLevel/` + params, {}, opts);
// 管理员-课程范围
export const queryCourseByStructId = (params, opts) => request("/api-course/course/queryCourseByStructId", params, { ...opts, method: "post" })
// 查看机构组织已开通的产品
export const queryOpenedProd = (params, opts) => request("/api-user/sys/share/queryOpenedProd", params, { ...opts, method: "post" })

// 查看试卷资源
export const queryTestPaperNum = (params, opts) => request("/api-course/course/queryTestPaperNum", params, { ...opts, method: "post" })
// 查看接口即将过期的产品
export const queryWillExpiredProd = (params, opts) => request("/api-user/sys/share/queryWillExpiredProd", params, opts)
// 查看机构已过期的产品
export const queryExpiredPro = (params, opts) => request("/api-user/sys/share/queryExpiredProd", params, opts)
// 数据更新时间
export const getFamousQuotes = (params, opts) => request('/api-cms/famousQuotes/get', params, opts);

// 产品统计接口 试卷、资源、素材、视频、题库
export const findCourseSummary = (params, opts) => request("/api-data/staCourseResource/course/summary", params, { ...opts, method: "post" })



// -------------------------资源统计------------------------------


// -------------------------资源统计 教师------------------------------
// 教师-课程范围
export const findCourseByUserType = (params, opts) => request("/api-course/course/findByUserType", params, { ...opts, method: "post" })
// 教师资源统计-素材总数
export const findResourceNum = (params, opts) => request("/api-course/course/findResourceNum", params, { ...opts, method: "post" })
// 教师资源统计-素材总量
export const findResourceSize = (params, opts) => request("/api-course/course/findResourceSize", params, { ...opts, method: "post" })
// 教师资源统计-视频时长
export const findVideoTime = (params, opts) => request("/api-course/course/findVideoTime", params, { ...opts, method: "post" })
// 教师资源统计-题库数量
export const findQuestionNum = (params, opts) => request("/api-course/course/findQuestionNum", params, { ...opts, method: "post" })

// 教师资源统计-素材分类统计
// export const findResourceTypeCount = (params, opts) => request("/api-course/course/findResourceTypeCount", params, { ...opts, method: "post" })
export const findResourceTypeCount = (params, opts) => request("/api-data/staCourseResource/course/findResourceTypeCount", params, { ...opts, method: "post" })
// 教师资源统计-资源活跃度占比
export const findResourceActivityRatio = (params, opts) => request("/api-data/staCourseResource/course/findResourceActivityRatio", params, { ...opts, method: "post" })

// 教师资源统计-主客观题占比
export const findQuestionRatio = (params, opts) => request("/api-data/staCourseResource/course/findQuestionRatio", params, { ...opts, method: "post" })
// 教师资源统计-按题型分类统计
export const findQuestionTypeCount = (params, opts) => request("/api-data/staCourseResource/course/findQuestionTypeCount", params, { ...opts, method: "post" })
// 教师资源统计-按试题难易程度统计
export const findQuestionDiffcultyCount = (params, opts) => request("/api-data/staCourseResource/course/findQuestionDiffcultyCount", params, { ...opts, method: "post" })
//


// WEBPACK FOOTER //
// ./src/api/resourceStatistic.js